export class DashboardPizzaRQ {
  public dtVoo: string;

  constructor(){
    this.dtVoo = '';
  }
}
